import { Component, OnInit, Input } from "@angular/core";
// import {ApirequestService} from '../../../../../../shared/services/apirequest.service';
import { MatTableDataSource } from "@angular/material";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment/moment";
import { Router, ActivatedRoute } from "@angular/router";
import { first, last } from "rxjs/operators";
import { FileService } from "src/app/shared/services/file.service";
import * as _ from "lodash";
import { MatSnackBar } from "@angular/material";
import choice from "../../../../../shared/choices";

import { Measure } from "../../measures/measure-form/model/measure.model"; // Import the user model
import { ApirequestService } from "../../../../../shared/services/apirequest.service";
import { AlertService } from "../../../../../shared/services/alert.service";
import { CustomSnackBarComponent } from "../../../../../shared/common/custom-snack-bar/custom-snack-bar.component";
import { StudiesSharedService } from "./../../measures/measure-form/studies-shared-service/studies-shared.service";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { MessageService } from "./author-design/message.service";
import { MatDialog } from "@angular/material/dialog";
import { MeasuresDialogComponent } from "./measures-dialog/dialog.component";
import { RepositorySharedService } from "./repository-shared-service/repository-shared.service";
import { InterventionsDialogComponent } from "../../interventions-container/interventions-form/interventions-dialog/interventions-dialog.component";
import { BehaviorsDialogComponent } from "../../behavior-container/behaviors-form/behaviors-dialog/behaviors-dialog.component";

@Component({
  selector: "app-dashboard-measure-form-study-evidence",
  templateUrl: "./study-evidence.component.html",
  styleUrls: ["./study-evidence.component.css"],
})
export class RevisedDashboardStudyEvidenceFormComponent implements OnInit {
  loading: boolean;
  start_date: string = "";
  end_date: string = "";
  url: string;
  topHeaders: string[] = ["channelGrouping", "acquisition", "behavior"];
  displayedColumns: string[] = [
    "totalUsers",
    "usersWhoEngagedWithPlatform",
    "newUsers",
    "sessions",
    "avgSessionDuration",
    "bounceRate",
  ];
  alldisplayedColumns: string[] = [
    "channelGrouping",
    "totalUsers",
    "usersWhoEngagedWithPlatform",
    "newUsers",
    "sessions",
    "avgSessionDuration",
    "bounceRate",
  ];
  dataSource: MatTableDataSource<any>;
  domainsFiltersList = [];
  behaviorsFiltersList = [];
  populationFiltersList = [];

  measurementModeFilters = [];

  languagesFiltersList = [];
  durationFilters = [];
  databaseFilters = [];
  choices = choice;

  domains_url_filters = "measures/domains_list/";
  behavior_url_measurefilters = "measures/behaviors_list/";
  population_url_measurefilters = "measures/population_list/";
  // Measurement mode
  language_url_measurefilters = "measures/languages_list/";
  // duration
  // measure_source

  selectedDomain: any;
  selectedBehavior: any;
  selectedPopulation: string;
  selectedMeasurementMode: string;
  selectedLanguage: any;
  selectedDuration: string;
  selectedDatabase: string;
  selectedUploadedBy: string;
  searchTerm: string;
  selectedStatus: string;
  typeOfStudy: string;
  studyDesign: string;

  filter_url = {};
  page: number;
  total: number;
  page_size: number;
  total_pages: number;
  addToMeasure: boolean = true;
  addToIntervention: boolean = false;
  addToBehavior: boolean = false;

  repositoryTypeOptions = {
    measure: [
      {
        value: "Measures",
        title:
          "The construct has been measured with proper tests of validity and reliability.",
        label: "Measure",
      },
      {
        value: "Influence",
        title:
          "The construct has been influenced by researchers via manipulation or intervention.",
        label: "Influence",
      },
      {
        value: "Behavior change validation",
        title:
          "The construct has been shown to impact a behavioral outcome such that changes in the measure due to an intervention or manipulation lead to changes in the outcome.",
        label: "Behavior change validation",
      },
    ],
    intervention: [
      {
        value: "Influence",
        title:
          "The construct has been influenced by researchers via manipulation or intervention.",
        label: "Influence",
      },
      {
        value: "Behavior change validation",
        title:
          "The construct has been shown to impact a behavioral outcome such that changes in the measure due to an intervention or manipulation lead to changes in the outcome.",
        label: "Behavior change validation",
      },
    ],
    behavior: [
      {
        value: "Behavior change validation",
        title:
          "The construct has been shown to impact a behavioral outcome such that changes in the measure due to an intervention or manipulation lead to changes in the outcome.",
        label: "Behavior change validation",
      },
    ],
  };

  filteredStudyOptions = [];
  filteredRepositoryOptions = [];
  selectedRepository = "measure";

  measures: any[];

  items = ["All", "Pending", "Published", "Draft"];
  // activeIndex: number | null = null;
  activeIndex: number = 0; // Set default to 0 (first item)
  measureForm: FormGroup;
  formSubmitted: boolean;
  loadedmeasure: any;
  isNewMeasure: boolean;
  submitted: boolean;
  @Input() id: string;
  @Input() sourceData: any;

  shortDescriptionHtmlContent = "";
  influenceStudiesHtmlContent = "";
  behaviorIndicatorHtmlContent = "";
  authorsHtmlContent = "";

  /*
  this.measureForm = this.fb.group({
      id: '',
      // detailsid: '',
      title: ['', Validators.required],
      type_of_study: '',
      authors: [[]],
      sample_size: '',
      short_description: ['', Validators.required],
      influence_studies: '', //this.formBuilder.array([this.initTargetPopulation()]),
      behavior_indicator: '',
      study_link: ['', Validators.required],
      suppliment_materials_link: ''
      
    });
  
  */

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Max 150 characters",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  config2: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "7.5rem",
    minHeight: "2.5rem",
    placeholder: "",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };
  receivedMessage: any;
  allAuthors = [];
  selectedMeasures = [];
  measureReceivedData: any;

  sexChoices = ["female sex", "male sex", "intersex/other"];
  sexFieldChoicesList: any[];

  genderChoices = ["women", "men", "nonbinary/genderqueer/other"];
  genderFieldChoicesList: any[];

  raceChoices: any[];
  raceFieldChoicesList: any[];

  ethnicityChoices = ["Hispanic", "Not Hispanic"];
  ethnicityFieldChoicesList: any[];

  countryChoices = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo, Democratic Republic of the",
    "Congo, Republic of the",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, North",
    "Korea, South",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];
  countryFieldChoicesList: any[];
  studyLinkFieldChoicesList: any[];
  supplimentMaterialsFieldChoicesList: any[];

  constructor(
    private apirequestService: ApirequestService,
    private router: Router,
    private fileService: FileService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public alertService: AlertService,
    private studiesSharedService: StudiesSharedService,
    private repositorySharedService: RepositorySharedService,
    private messageService: MessageService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    if (this.sourceData) {
      if (this.sourceData.source == "measure_form") {
        this.filteredStudyOptions = this.repositoryTypeOptions["measure"]; // Direct assignment
        this.filteredRepositoryOptions = [
          {
            value: "measure",
            title: "",
            label: "Measure",
          },
        ];
      }
      if (this.sourceData.source == "behavior_form") {
        this.filteredStudyOptions = this.repositoryTypeOptions["behavior"]; // Direct assignment
        this.filteredRepositoryOptions = [
          {
            value: "behavior",
            title: "",
            label: "Behavior",
          },
        ];
      }
      if (this.sourceData.source == "intervention_form") {
        this.filteredStudyOptions = this.repositoryTypeOptions["intervention"]; // Direct assignment
        this.filteredRepositoryOptions = [
          {
            value: "intervention",
            title: "",
            label: "Intervention",
          },
        ];
      }
    } else {
      this.filteredStudyOptions = this.repositoryTypeOptions["measure"]; // Direct assignment
      this.filteredRepositoryOptions = [
        {
          value: "measure",
          title: "",
          label: "Measure",
        },
        {
          value: "intervention",
          title: "",
          label: "Intervention",
        },
        {
          value: "behavior",
          title: "",
          label: "Behavior",
        },
      ];
    }
    this.sexFieldChoicesList = [];
    this.genderFieldChoicesList = [];
    this.raceFieldChoicesList = [];
    this.ethnicityFieldChoicesList = [];
    this.countryFieldChoicesList = [];
    this.studyLinkFieldChoicesList = [];
    this.supplimentMaterialsFieldChoicesList = [];
    // this.sexData = {
    //   index: this.generateUUID(),
    //   value: '',
    //   field_name:'sex',
    //   field_choices: ['female sex', 'male sex', 'intersex/other']
    // };
    // this.raceChoices = [''];

    // this.addExtraField('add', 'sex');
    // this.addExtraField('add', 'gender');
    // this.addExtraField('add', 'race');
    // this.addExtraField('add', 'ethnicity');
    // this.addExtraField('add', 'country');

    this.repositorySharedService.data$.subscribe((data) => {
      if (data != undefined) {
        console.log(`data=${JSON.stringify(data)}`);
        this.measureReceivedData = data;
        console.log(
          `studyReceivedData=${JSON.stringify(this.measureReceivedData)}`
        );

        this.selectedMeasures.push({
          id: this.measureReceivedData.id,
          title: this.measureReceivedData.title,
        });
      }
    });

    this.addFirstAuthor();
    this.messageService.message$.subscribe((message) => {
      this.receivedMessage = message; // Received message: {"type":"add","index":0}

      console.log(`Received message: ${JSON.stringify(this.receivedMessage)}`);
      if (this.receivedMessage.type == "add") {
        console.log(`Received message_use: ${this.receivedMessage}`);
        let w = this.allAuthors;
        // w.push({id: this.allAuthors.length, firstName: '', lastName: ''}); // this.receivedMessage.index
        // let authorItem = {index: this.allAuthors.length, topItemIndex: this.allAuthors.length - 1, bottomItemIndex: undefined, firstName: '', lastName: ''};
        let authorItem = {
          index: this.generateUUID(),
          topItemIndex:
            this.allAuthors[this.allAuthors.length - 1].topItemIndex,
          bottomItemIndex: undefined,
          firstName: "",
          lastName: "",
        };
        // let authorItem = {index: this.receivedMessage.index, topItemIndex: this.receivedMessage.topIndex, bottomItemIndex: this.receivedMessage.bottomIndex, firstName: '', lastName: ''};
        w.push(authorItem);
        this.allAuthors = w;
      } else if (this.receivedMessage.type == "remove") {
        // this.allAuthors.splice(this.receivedMessage.index, 1);
        this.allAuthors = this.allAuthors.filter(
          (item) => item["index"] !== this.receivedMessage.index
        );
      } else if (this.receivedMessage.type == "update_record") {
        let data = this.receivedMessage.data;
        // let currAuthors = this.allAuthors;
        this.allAuthors.forEach((curr) => {
          if (curr.index == data.id) {
            curr.firstName = data.firstName;
            curr.lastName = data.lastName;
          }
        });
        // console.log(`allAuthors=${JSON.stringify(this.allAuthors)}`);
      } else if (this.receivedMessage.type == "extra_fields") {
        if (this.receivedMessage.field_name == "sex") {
          this.sexFieldChoicesList.forEach((sexItem) => {
            if (sexItem.index == this.receivedMessage.index) {
              sexItem.choice_name = this.receivedMessage.choice_name;
              sexItem.value = this.receivedMessage.value;
            }
          });
        } else if (this.receivedMessage.field_name == "gender") {
          this.genderFieldChoicesList.forEach((sexItem) => {
            if (sexItem.index == this.receivedMessage.index) {
              sexItem.choice_name = this.receivedMessage.choice_name;
              sexItem.value = this.receivedMessage.value;
            }
          });
        } else if (this.receivedMessage.field_name == "race") {
          this.raceFieldChoicesList.forEach((sexItem) => {
            if (sexItem.index == this.receivedMessage.index) {
              sexItem.choice_name = this.receivedMessage.choice_name;
              sexItem.value = this.receivedMessage.value;
            }
          });
        } else if (this.receivedMessage.field_name == "ethnicity") {
          this.ethnicityFieldChoicesList.forEach((sexItem) => {
            if (sexItem.index == this.receivedMessage.index) {
              sexItem.choice_name = this.receivedMessage.choice_name;
              sexItem.value = this.receivedMessage.value;
            }
          });
        } else if (this.receivedMessage.field_name == "country") {
          this.countryFieldChoicesList.forEach((sexItem) => {
            if (sexItem.index == this.receivedMessage.index) {
              sexItem.choice_name = this.receivedMessage.choice_name;
              sexItem.value = this.receivedMessage.value;
            }
          });
        } else if (this.receivedMessage.field_name == "study_link") {
          this.studyLinkFieldChoicesList.forEach((studyLinkItem) => {
            if (studyLinkItem.index == this.receivedMessage.index) {
              studyLinkItem.choice_name = this.receivedMessage.choice_name;
              studyLinkItem.value = this.receivedMessage.value;
            }
          });
        } else if (
          this.receivedMessage.field_name == "suppliment_materials_link"
        ) {
          this.supplimentMaterialsFieldChoicesList.forEach(
            (supplimentMaterialLinkItem) => {
              if (
                supplimentMaterialLinkItem.index == this.receivedMessage.index
              ) {
                supplimentMaterialLinkItem.choice_name =
                  this.receivedMessage.choice_name;
                supplimentMaterialLinkItem.value = this.receivedMessage.value;
              }
            }
          );
        }
      } else if (this.receivedMessage.type == "extra_fields_remove_item") {
        if (this.receivedMessage.field_name == "sex") {
          this.sexFieldChoicesList = this.removeItemFromArray(
            this.sexFieldChoicesList,
            this.receivedMessage.index
          );
        } else if (this.receivedMessage.field_name == "gender") {
          this.genderFieldChoicesList = this.removeItemFromArray(
            this.genderFieldChoicesList,
            this.receivedMessage.index
          );
        } else if (this.receivedMessage.field_name == "race") {
          this.raceFieldChoicesList = this.removeItemFromArray(
            this.raceFieldChoicesList,
            this.receivedMessage.index
          );
        } else if (this.receivedMessage.field_name == "ethnicity") {
          this.ethnicityFieldChoicesList = this.removeItemFromArray(
            this.ethnicityFieldChoicesList,
            this.receivedMessage.index
          );
        } else if (this.receivedMessage.field_name == "country") {
          this.countryFieldChoicesList = this.removeItemFromArray(
            this.countryFieldChoicesList,
            this.receivedMessage.index
          );
        } else if (this.receivedMessage.field_name == "study_link") {
          this.studyLinkFieldChoicesList = this.removeItemFromArray(
            this.studyLinkFieldChoicesList,
            this.receivedMessage.index
          );
        } else if (
          this.receivedMessage.field_name == "suppliment_materials_link"
        ) {
          this.supplimentMaterialsFieldChoicesList = this.removeItemFromArray(
            this.supplimentMaterialsFieldChoicesList,
            this.receivedMessage.index
          );
        }
      }
    });

    this.isNewMeasure = true;
    this.submitted = false;
    this.page = 1;
    this.total = 0;
    this.page_size = 20;
    this.searchTerm = "";
    this.selectedDomain = {};
    //  this.selectedBehaviour = {};
    this.selectedPopulation = "All";
    this.selectedMeasurementMode = "All";
    //  this.selectedLanguage = 'Not specified';
    this.selectedDuration = "All";
    this.selectedDatabase = "All";
    this.selectedUploadedBy = "All";
    this.selectedStatus = "All";

    this.route.params.subscribe((params) => {
      this.id = params["id"] || "";
    });

    this.getFilters();
    this.createForm();
    if ((this.id != "" || this.id != undefined) && this.id != "new") {
      this.getFormData();
    } else {
      this.addExtraField("add", "sex");
      this.addExtraField("add", "gender");
      this.addExtraField("add", "race");
      this.addExtraField("add", "ethnicity");
      this.addExtraField("add", "country");
      this.addExtraField("add", "study_link");
      this.addExtraField("add", "suppliment_materials_link");
    }
  }

  removeItemFromArray(array: any[], index: string) {
    return array.filter((item) => item.index !== index);
  }

  createForm() {
    this.measureForm = this.fb.group({
      id: "",
      // detailsid: '',
      title: ["", Validators.required],
      type_of_study: "",
      authors: [[]],
      sample_size: "",
      short_description: ["", Validators.required],
      influence_studies: "", //this.formBuilder.array([this.initTargetPopulation()]),
      behavior_indicator: "",
      study_link: ["", Validators.required],
      suppliment_materials_link: "",
      country: "",
      sex: "",
      gender: "",
      age: "",
      race: "",
      ethnicity: "",
      selected_measures: ["", Validators.required],
      // study_design: ['', Validators.required],
      study_design: "",
    });

    // title
    // type_of_study
    // authors
    // sample_size
    // short_description
    // influence_studies
    // behavior_indicator
    // study_link
  }

  getFilters() {
    this.apirequestService.get(this.domains_url_filters).subscribe(
      (res) => {
        this.domainsFiltersList = res.results;
      },
      (error) => {
        console.log(error);
      }
    );

    this.apirequestService.get(this.behavior_url_measurefilters).subscribe(
      (res) => {
        this.behaviorsFiltersList = res.results;
      },
      (error) => {
        console.log(error);
      }
    );

    this.apirequestService.get(this.language_url_measurefilters).subscribe(
      (res) => {
        this.languagesFiltersList = res.results;
      },
      (error) => {
        console.log(error);
      }
    );

    this.apirequestService.get(this.population_url_measurefilters).subscribe(
      (res) => {
        this.populationFiltersList = res.results;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  onSelectChange(item_name: string, event: any) {
    const selectedValue = event.target.value;
    if (item_name == "domains") {
      this.selectedDomain = selectedValue;
    } else if (item_name == "behaviors") {
      this.selectedBehavior = selectedValue;
    } else if (item_name == "target_population") {
      this.selectedPopulation = selectedValue;
    }
    if (item_name == "measurement_mode") {
      this.selectedMeasurementMode = selectedValue;
    } else if (item_name == "language") {
      this.selectedLanguage = selectedValue;
    } else if (item_name == "duration") {
      this.selectedDuration = selectedValue;
    }
    if (item_name == "database") {
      this.selectedDatabase = selectedValue;
    } else if (item_name == "uploaded_by") {
      this.selectedUploadedBy = selectedValue;
    } else if (item_name == "type_of_study") {
      this.typeOfStudy = selectedValue;
    } else if (item_name == "study_design") {
      this.studyDesign = selectedValue;
    }
  }

  onRepositoryChange(event: any) {
    const selected = event.target.value;
    this.filteredStudyOptions = this.repositoryTypeOptions[selected] || [];
    this.selectedRepository = selected;
    if (selected == "measure") {
      this.addToMeasure = true;
      this.addToIntervention = false;
      this.addToBehavior = false;
    }
    if (selected == "intervention") {
      this.addToMeasure = false;
      this.addToIntervention = true;
      this.addToBehavior = false;
    }
    if (selected == "behavior") {
      this.addToMeasure = false;
      this.addToIntervention = false;
      this.addToBehavior = true;
    }
  }

  formatDate(inputDate) {
    // Create a new Date object from the input date string
    const date = new Date(inputDate);

    // Extract the day, month, and year from the date object
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month starts from 0
    const year = date.getFullYear();

    // Pad day and month with leading zeros if necessary
    const paddedDay = day < 10 ? "0" + day : day;
    const paddedMonth = month < 10 ? "0" + month : month;

    // Format the date as "DD/MM/YYYY"
    const formattedDate = `${paddedDay}/${paddedMonth}/${year}`;

    return formattedDate;
  }

  isOdd(num: number): boolean {
    return num % 2 !== 0;
  }

  isMultipleOf4(number) {
    return number % 4 === 0;
  }

  onKeyUp(event: any) {
    // You can access the value of the input field using event.target.value
    const enteredValue = event.target.value;
    console.log("Entered value:", enteredValue);

    // Here you can perform any actions based on the entered value
    this.searchTerm = enteredValue;
  }

  filter_data() {}

  handleClick(index: number) {
    this.activeIndex = index;
    this.selectedStatus = this.items[index];
  }

  updateAuthorDetails(id: string, first_name: string, last_name: string) {}

  openMeasureDialog(): void {
    const dialogRef = this.dialog.open(MeasuresDialogComponent, {
      // width: '250px'
      width: "300%",
      height: "2500px",
      data: { sourceData: { source: "study_form", source_id: this.id } },
    });
    // After the dialog has been opened, let us update the data object
    dialogRef.componentInstance.data.sourceData.dialogRef = dialogRef;

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }
  openInterventionDialog(): void {
    const dialogRef = this.dialog.open(InterventionsDialogComponent, {
      // width: '250px'
      width: "300%",
      height: "2500px",
      data: { sourceData: { source: "study_form", source_id: this.id } },
    });
    // After the dialog has been opened, let us update the data object
    dialogRef.componentInstance.data.sourceData.dialogRef = dialogRef;

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  openBehaviorDialog(): void {
    const dialogRef = this.dialog.open(BehaviorsDialogComponent, {
      // width: '250px'
      width: "300%",
      height: "2500px",
      data: { sourceData: { source: "study_form", source_id: this.id } },
    });
    // After the dialog has been opened, let us update the data object
    dialogRef.componentInstance.data.sourceData.dialogRef = dialogRef;

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  removeMeasureStudy(study: any) {
    this.selectedMeasures = this.selectedMeasures.filter(
      (item) => item !== study
    );
  }
  onSubmit() {
    this.formSubmitted = true;
    console.log("submit called");
    console.log(`allAuthors=${JSON.stringify(this.allAuthors)}`);
    this.measureForm.patchValue({
      authors: this.allAuthors,
    });

    let sexValues = [];
    this.sexFieldChoicesList.forEach((curr) => {
      if (curr.value != "" && curr.value != undefined) {
        sexValues.push(curr);
      }
    });

    let genderValues = [];
    this.genderFieldChoicesList.forEach((curr) => {
      if (curr.value != "" && curr.value != undefined) {
        genderValues.push(curr);
      }
    });

    let raceValues = [];
    this.raceFieldChoicesList.forEach((curr) => {
      if (curr.value != "" && curr.value != undefined) {
        raceValues.push(curr);
      }
    });

    let ethnicityValues = [];
    this.ethnicityFieldChoicesList.forEach((curr) => {
      if (curr.value != "" && curr.value != undefined) {
        ethnicityValues.push(curr);
      }
    });

    let countryValues = [];
    this.countryFieldChoicesList.forEach((curr) => {
      if (curr.value != "" && curr.value != undefined) {
        countryValues.push(curr);
      }
    });

    this.measureForm.patchValue({
      sex: sexValues,
    });
    this.measureForm.patchValue({
      gender: genderValues,
    });
    this.measureForm.patchValue({
      race: raceValues,
    });
    this.measureForm.patchValue({
      ethnicity: ethnicityValues,
    });
    this.measureForm.patchValue({
      country: countryValues,
    });
    this.measureForm.patchValue({
      selected_measures:
        this.selectedMeasures.length > 0 ? this.selectedMeasures : "",
    });

    let studyLinkValues = [];
    this.studyLinkFieldChoicesList.forEach((curr) => {
      if (curr.value != "" && curr.value != undefined) {
        studyLinkValues.push(curr);
      }
    });

    this.measureForm.patchValue({
      study_link: studyLinkValues.length > 0 ? studyLinkValues : "",
    });

    let supplimentMaterialsLinkValues = [];
    this.supplimentMaterialsFieldChoicesList.forEach((curr) => {
      if (curr.value != "" && curr.value != undefined) {
        supplimentMaterialsLinkValues.push(curr);
      }
    });

    this.measureForm.patchValue({
      suppliment_materials_link:
        supplimentMaterialsLinkValues.length > 0
          ? supplimentMaterialsLinkValues
          : "",
    });

    let measureData = this.measureForm.value;
    console.log(measureData);

    if (this.measureForm.valid) {
      // Check if the form is valid
      // Process form submission
      this.formSubmitted = false;
      console.log(measureData);

      this.submitted = true;
      // stop here if form is invalid
      if (this.measureForm.invalid) {
        return;
      }
      this.loading = true;
      let theForm = this.measureForm.value;
      // theForm['domains'].value = [theForm['domains']];
      theForm.short_description = this.shortDescriptionHtmlContent;
      ////theForm.influence_studies = this.influenceStudiesHtmlContent;
      ////theForm.behavior_indicator = this.behaviorIndicatorHtmlContent;
      // theForm.authors = this.authorsHtmlContent;
      this.allAuthors.forEach((curr) => {
        if (curr.firstName == "" && curr.lastName == "") {
          this.allAuthors = this.allAuthors.filter(
            (item) => item["index"] !== curr.index
          );
        } else if (curr.firstName == undefined && curr.lastName == undefined) {
          this.allAuthors = this.allAuthors.filter(
            (item) => item["index"] !== curr.index
          );
        }
      });
      theForm.authors = this.allAuthors;

      try {
        theForm.domains = theForm.domains
          .split(",")
          .map((domain) => ({ id: domain.trim() }));
      } catch (e) {}
      try {
        theForm.behaviors = theForm.behaviors
          .split(",")
          .map((behavior) => ({ id: behavior.trim() }));
      } catch (e) {}

      console.log(`theForm=${JSON.stringify(theForm)}`);
      if (this.measureForm.get("id").value === "") {
        console.log("Calling create");
        const url = "study_evidence/study_evidence/";
        this.apirequestService
          .post(url, theForm)
          .pipe(first())
          .subscribe(
            (data) => {
              this.id = data.id;
              this.snackBar.openFromComponent(CustomSnackBarComponent, {
                data: {
                  message: "Study evidence saved",
                  action: "Success",
                },
                duration: 3 * 1000,
                panelClass: ["transparent-snack-bar"],
              });
              if (this.sourceData != undefined) {
                // || this.sourceData.source_id != undefined
                this.studiesSharedService.sendData(data);
                let dialogRef = this.sourceData.dialogRef;
                dialogRef.close();
              }
              this.loading = false;
              // this.viewStudies.emit(this.id);
              this.addStudyToMeasures(this.id, this.selectedMeasures);
              // Redirect to the item update page
              this.measureForm.patchValue({
                id: this.id,
              });
              let url = `/dashboard/study-evidence/${this.id}`;
              this.router.navigate([url]);
              // window.location.assign(url);
              console.log();
            },
            (error) => {
              this.alertService.error(error, "");
              this.loading = false;
            }
          );
      } else {
        // if(theForm.id === '' || theForm.id === 'new'){
        //   theForm.id = this.id;
        // }
        console.log("Calling update");
        const url = "study_evidence/update/";
        this.apirequestService
          .post(url, theForm)
          .pipe(first())
          .subscribe(
            (data) => {
              this.snackBar.openFromComponent(CustomSnackBarComponent, {
                data: {
                  message: "Study successfully updated",
                  action: "Success",
                },
                duration: 3 * 1000,
                panelClass: ["transparent-snack-bar"],
              });
              this.loading = false;
              this.addStudyToMeasures(theForm.id, this.selectedMeasures);
            },
            (error) => {
              this.alertService.error(error, "");
              this.loading = false;
            }
          );
      }

      // Proceed with your logic
      // console.log(measureData);
    }
    // else{
    //   // Form is invalid, handle errors
    //   // console.log('Form has errors');
    //   // const titleError = this.measureForm.get('title').errors;
    //   const controlErrors = this.getControlErrors();
    //   console.log('Form has errors:', controlErrors);
    //   return;
    // }
  }

  private addStudyToMeasures(study_id: string, measuresList: any[]) {
    console.log(`Adding study to measures.`);
    let payload = {
      study_id: study_id,
      measure_ids: [],
      intervention_ids: [],
      behavior_ids: [],
    };
    if (measuresList.length > 0) {
      measuresList.forEach((currId) => {
        if (this.selectedRepository == "measure") {
          payload.measure_ids.push(currId);
        }
        if (this.selectedRepository == "intervention") {
          payload.intervention_ids.push(currId);
        }
        if (this.selectedRepository == "behavior") {
          payload.behavior_ids.push(currId);
        }
      });
    }
    console.log(`Payload=${JSON.stringify(payload)}`);

    console.log("Calling add study to measures.");
    const url = "study_evidence/add-studies-to-measure/";
    this.apirequestService
      .post(url, payload)
      .pipe(first())
      .subscribe(
        (data) => {
          this.snackBar.openFromComponent(CustomSnackBarComponent, {
            data: {
              message: "Study successfully updated",
              action: "Success",
            },
            duration: 3 * 1000,
            panelClass: ["transparent-snack-bar"],
          });
          this.loading = false;
        },
        (error) => {
          this.alertService.error(error, "");
          this.loading = false;
        }
      );
  }

  private getControlErrors(): { [key: string]: any } {
    const errors = {};
    Object.keys(this.measureForm.controls).forEach((key) => {
      const control = this.measureForm.get(key);
      if (control.errors != null) {
        errors[key] = control.errors;
      }
    });
    return errors;
  }

  private getFormData() {
    if (this.id != "" || this.id != undefined) {
      this.isNewMeasure = false;
      const url = "study_evidence/details/" + this.id + "/";
      var can_edit_ = false;
      this.apirequestService.get(url).subscribe(
        (res) => {
          // res.domains = res.domains[0];
          this.measureForm.patchValue(res, { onlySelf: true });

          /////
          try {
            this.shortDescriptionHtmlContent = res.short_description;
          } catch (e) {}
          try {
            this.influenceStudiesHtmlContent = res.influence_studies;
          } catch (e) {}
          try {
            this.behaviorIndicatorHtmlContent = res.behavior_indicator;
          } catch (e) {}

          try {
            this.authorsHtmlContent = res.authors;
          } catch (e) {}

          try {
            this.typeOfStudy = res.type_of_study;
          } catch (e) {}

          try {
            this.selectedMeasures = res.measures;
          } catch (e) {}

          try {
            this.studyDesign = res.study_design;
          } catch (e) {}

          try {
            if (res.authors != "" && res.authors != undefined) {
              const validJsonString = res.authors.replace(/'/g, '"');
              // Parse the JSON string into an array of objects
              const authorsJson = JSON.parse(validJsonString);
              this.allAuthors = authorsJson;
              console.log(`Updated authors=${JSON.stringify(this.allAuthors)}`);
              if (this.allAuthors.length == 0) {
                let authorItem = {
                  index: this.generateUUID(),
                  topItemIndex: undefined,
                  bottomItemIndex: undefined,
                  firstName: "",
                  lastName: "",
                };
                let w = [];
                w.push(authorItem);
                this.allAuthors = w;
              }
            } else {
              let authorItem = {
                index: this.generateUUID(),
                topItemIndex: undefined,
                bottomItemIndex: undefined,
                firstName: "",
                lastName: "",
              };
              let w = [];
              w.push(authorItem);
              this.allAuthors = w;
            }
          } catch (e) {
            console.log(`Error updating authors=${e}`);
            if (this.allAuthors.length == 0) {
              let authorItem = {
                index: this.generateUUID(),
                topItemIndex: undefined,
                bottomItemIndex: undefined,
                firstName: "",
                lastName: "",
              };
              // this.allAuthors.push(authorItem);
              let w = [];
              w.push(authorItem);
              this.allAuthors = w;
            }
          }

          try {
            if (res.sex != "" && res.sex != undefined) {
              const validJsonString = res.sex.replace(/'/g, '"');
              // Parse the JSON string into an array of objects
              const authorsJson = JSON.parse(validJsonString);
              this.sexFieldChoicesList = authorsJson;
              if (this.sexFieldChoicesList.length == 0) {
                this.addExtraField("add", "sex");
              }
            } else {
              this.addExtraField("add", "sex");
            }
          } catch (e) {
            if (this.sexFieldChoicesList.length == 0) {
              this.addExtraField("add", "sex");
            }
          }

          try {
            if (res.gender != "" && res.gender != undefined) {
              const validJsonString = res.gender.replace(/'/g, '"');
              // Parse the JSON string into an array of objects
              const authorsJson = JSON.parse(validJsonString);
              this.genderFieldChoicesList = authorsJson;
              if (this.genderFieldChoicesList.length == 0) {
                this.addExtraField("add", "gender");
              }
            } else {
              this.addExtraField("add", "gender");
            }
          } catch (e) {
            if (this.genderFieldChoicesList.length == 0) {
              this.addExtraField("add", "gender");
            }
          }

          try {
            if (res.race != "" && res.race != undefined) {
              const validJsonString = res.race.replace(/'/g, '"');
              // Parse the JSON string into an array of objects
              const authorsJson = JSON.parse(validJsonString);
              this.raceFieldChoicesList = authorsJson;
              if (this.raceFieldChoicesList.length == 0) {
                this.addExtraField("add", "race");
              }
            } else {
              this.addExtraField("add", "race");
            }
          } catch (e) {
            if (this.raceFieldChoicesList.length == 0) {
              this.addExtraField("add", "race");
            }
          }

          try {
            if (res.ethnicity != "" && res.ethnicity != undefined) {
              const validJsonString = res.ethnicity.replace(/'/g, '"');
              // Parse the JSON string into an array of objects
              const authorsJson = JSON.parse(validJsonString);
              this.ethnicityFieldChoicesList = authorsJson;
              if (this.ethnicityFieldChoicesList.length == 0) {
                this.addExtraField("add", "ethnicity");
              }
            } else {
              this.addExtraField("add", "ethnicity");
            }
          } catch (e) {
            if (this.ethnicityFieldChoicesList.length == 0) {
              this.addExtraField("add", "ethnicity");
            }
          }

          try {
            if (res.country != "" && res.country != undefined) {
              const validJsonString = res.country.replace(/'/g, '"');
              // Parse the JSON string into an array of objects
              const authorsJson = JSON.parse(validJsonString);
              this.countryFieldChoicesList = authorsJson;
              if (this.countryFieldChoicesList.length == 0) {
                this.addExtraField("add", "country");
              }
            } else {
              this.addExtraField("add", "country");
            }
          } catch (e) {
            if (this.countryFieldChoicesList.length == 0) {
              this.addExtraField("add", "country");
            }
          }

          try {
            if (res.study_link != "" && res.study_link != undefined) {
              const validJsonString = res.study_link.replace(/'/g, '"');
              // Parse the JSON string into an array of objects
              const authorsJson = JSON.parse(validJsonString);
              this.studyLinkFieldChoicesList = authorsJson;
              if (this.studyLinkFieldChoicesList.length == 0) {
                this.addExtraField("add", "study_link");
              }
            } else {
              this.addExtraField("add", "study_link");
            }
          } catch (e) {
            if (res.study_link != "") {
              this.studyLinkFieldChoicesList = [
                {
                  index: this.generateUUID(),
                  value: res.study_link,
                  field_name: "study_link",
                  choice_name: "",
                  field_choices: [],
                },
              ];
            } else {
              if (this.studyLinkFieldChoicesList.length == 0) {
                this.addExtraField("add", "study_link");
              }
            }
          }

          try {
            if (
              res.suppliment_materials_link != "" &&
              res.suppliment_materials_link != undefined
            ) {
              const validJsonString = res.suppliment_materials_link.replace(
                /'/g,
                '"'
              );
              // Parse the JSON string into an array of objects
              const authorsJson = JSON.parse(validJsonString);
              this.supplimentMaterialsFieldChoicesList = authorsJson;
              if (this.supplimentMaterialsFieldChoicesList.length == 0) {
                this.addExtraField("add", "suppliment_materials_link");
              }
            } else {
              this.addExtraField("add", "suppliment_materials_link");
            }
          } catch (e) {
            if (res.suppliment_materials_link != "") {
              this.supplimentMaterialsFieldChoicesList = [
                {
                  index: this.generateUUID(),
                  value: res.suppliment_materials_link,
                  field_name: "suppliment_materials_link",
                  choice_name: "",
                  field_choices: [],
                },
              ];
            } else {
              if (this.supplimentMaterialsFieldChoicesList.length == 0) {
                this.addExtraField("add", "suppliment_materials_link");
              }
            }
          }

          console.log(
            `this.measureForm.=${JSON.stringify(this.measureForm.value)}`
          );
          // this.setTagetpopulationData(res);
          this.loadedmeasure = res;
          var user_ = JSON.parse(localStorage.getItem("auth.user"));
          if (
            res.researcher.id == user_["id"] ||
            user_["role"] == "Admin" ||
            user_["role"] == "System Admin"
          ) {
            can_edit_ = true;
          } else {
            res.co_owners.forEach(function (co_owner) {
              if (co_owner["id"] == user_["id"]) {
                can_edit_ = true;
              }
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  generateUUID() {
    // Generate a random hexadecimal string
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    // Concatenate the generated hexadecimal strings to form a UUID
    return (
      s4() +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      s4() +
      s4()
    );
  }

  addFirstAuthor() {
    if (this.allAuthors.length == 0) {
      this.allAuthors.push({
        index: this.generateUUID(),
        topItemIndex: undefined,
        bottomItemIndex: undefined,
        firstName: "",
        lastName: "",
      });
    }
  }

  addExtraField(command: string, field: string) {
    // this.sexFieldChoicesList.push(
    //   {
    //     index: this.generateUUID(),
    //     value: '',
    //     field_name:'sex',
    //     choice_name: '',
    //     field_choices: this.sexChoices
    //   }
    // );

    if (command == "add") {
      if (field == "sex") {
        this.sexFieldChoicesList.push({
          index: this.generateUUID(),
          value: "",
          field_name: "sex",
          choice_name: "",
          field_choices: this.sexChoices,
        });
      } else if (field == "gender") {
        this.genderFieldChoicesList.push({
          index: this.generateUUID(),
          value: "",
          field_name: field,
          choice_name: "",
          field_choices: this.genderChoices,
        });
      } else if (field == "race") {
        this.raceFieldChoicesList.push({
          index: this.generateUUID(),
          value: "",
          field_name: field,
          choice_name: "",
          field_choices: this.raceChoices,
        });
      } else if (field == "ethnicity") {
        this.ethnicityFieldChoicesList.push({
          index: this.generateUUID(),
          value: "",
          field_name: field,
          choice_name: "",
          field_choices: this.ethnicityChoices,
        });
      } else if (field == "country") {
        this.countryFieldChoicesList.push({
          index: this.generateUUID(),
          value: "",
          field_name: field,
          choice_name: "",
          field_choices: this.countryChoices,
        });
      } else if (field == "study_link") {
        this.studyLinkFieldChoicesList.push({
          index: this.generateUUID(),
          value: "",
          field_name: field,
          choice_name: "",
          field_choices: [],
        });
      } else if (field == "suppliment_materials_link") {
        this.supplimentMaterialsFieldChoicesList.push({
          index: this.generateUUID(),
          value: "",
          field_name: field,
          choice_name: "",
          field_choices: [],
        });
      }
    }
  }
}
